import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
import { track } from '../../utils/analytics';
import { SearchIntelligenceVisual } from './SearchIntelligenceVisual';
const EASE = [0.23, 1, 0.32, 1] as const;
export function EscaHero() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const onCta = (e: React.MouseEvent) => {
    e.preventDefault();
    track('hero_cta_click');
    document.getElementById('discuss')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="top" className="relative bg-ink text-sand pt-28 lg:pt-36 pb-16 lg:pb-24" data-id="element-340" data-mp="1m7he1eo2iafm">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8" data-id="element-341" data-mp="1qbyvh76ygbn8">
        <div className="grid lg:grid-cols-[55fr_45fr] gap-12 lg:gap-16 items-center" data-id="element-342" data-mp="2xoz6hi077nmu">
          {/* Text */}
          <div data-id="element-343" data-mp="31orglz58q1ub">
            <motion.p initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            ease: EASE
          }} className="esca-eyebrow text-accent" data-id="element-344" data-mp="31o81eq6z5rjz">
              {c.hero.eyebrow}
            </motion.p>

            <motion.h1 initial={{
            opacity: 0,
            y: 18
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.06,
            ease: EASE
          }} className="esca-h1 mt-5 text-sand max-w-[16ch] text-balance" data-id="element-345" data-mp="23i7rjq70zt7n">
              {c.hero.h1}
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.55,
            delay: 0.14,
            ease: EASE
          }} className="esca-lead mt-7 text-muted-light max-w-[52ch]" data-id="element-346" data-mp="1pq1ck7flzs9s">
              {c.hero.lead}
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.22,
            ease: EASE
          }} className="mt-9" data-id="element-347" data-mp="16t9we6vd5t9y">
              <a href="#discuss" onClick={onCta} className="group inline-flex w-full sm:w-auto items-center justify-center gap-2.5 px-8 py-4 text-base font-semibold text-white bg-accent hover:bg-accent-600 transition-colors duration-200" data-id="element-348" data-mp="117hqize0izvc">
                {c.hero.cta}
                <ArrowRightIcon className="w-4 h-4 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-349" data-mp="1fwnn0flgubzj" />
              </a>
            </motion.div>

            <motion.dl initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.3,
            ease: EASE
          }} className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-7 border-t border-line-dark pt-8" data-id="element-350" data-mp="1674459xr6i4o">
              {c.hero.facts.map(f => <div key={f.label} data-id="element-351" data-mp="23nt1orfo6y89">
                  <dt className="font-display text-2xl lg:text-[1.75rem] font-bold text-sand tracking-[-0.03em] leading-none" data-id="element-352" data-mp="3oblpy6vzrqg3">
                    {f.value}
                  </dt>
                  <dd className="mt-2 text-[0.8125rem] text-muted leading-snug" data-id="element-353" data-mp="z1j089ysdlk">
                    {f.label}
                  </dd>
                </div>)}
            </motion.dl>
          </div>

          {/* Visual */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.7,
          delay: 0.15,
          ease: EASE
        }} data-id="element-354" data-mp="35eau6w9kjf5e">
            <SearchIntelligenceVisual caption={c.hero.visualCaption} data-id="element-355" data-mp="3eeh304ubnqy8" />
          </motion.div>
        </div>
      </div>
    </section>;
}